export default {"src":"/_next/static/media/Twiter.e34fba1b.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};